import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearCustomRequest, customRequestApis, } from "../../../store/customRequest/actions";
var REQUEST_KEY = "getRejectionCodeSets";
var FETCH_ALL_LIMIT = 200;
export var useGetRejectionCodeSets = function () {
    var dispatch = useDispatch();
    var rejectionCodeSetsResponse = useSelector(function (state) { var _a, _b, _c; return (_c = (_b = (_a = state.CustomRequest) === null || _a === void 0 ? void 0 : _a.dataCustomRequest) === null || _b === void 0 ? void 0 : _b[REQUEST_KEY]) !== null && _c !== void 0 ? _c : null; });
    var loadingRejectionCodeSets = useSelector(function (state) { var _a, _b, _c; return (_c = (_b = (_a = state.CustomRequest) === null || _a === void 0 ? void 0 : _a.loadingCustomRequest) === null || _b === void 0 ? void 0 : _b[REQUEST_KEY]) !== null && _c !== void 0 ? _c : false; });
    var errorRejectionCodeSets = useSelector(function (state) { var _a, _b, _c; return (_c = (_b = (_a = state.CustomRequest) === null || _a === void 0 ? void 0 : _a.errorCustomRequest) === null || _b === void 0 ? void 0 : _b[REQUEST_KEY]) !== null && _c !== void 0 ? _c : null; });
    var fetchRejectionCodeSets = function () {
        dispatch(customRequestApis({
            requestKey: REQUEST_KEY,
            method: "GET",
            path: "/billing/Api/V1/RejectionCodes",
            queryParams: {
                enable: true,
                deleted: false,
                page: 1,
                limit: FETCH_ALL_LIMIT,
            },
        }));
    };
    var clearRejectionCodeSets = function () {
        dispatch(clearCustomRequest(REQUEST_KEY));
    };
    useEffect(function () {
        return function () {
            dispatch(clearCustomRequest(REQUEST_KEY));
        };
    }, []);
    return {
        fetchRejectionCodeSets: fetchRejectionCodeSets,
        clearRejectionCodeSets: clearRejectionCodeSets,
        rejectionCodeSetsResponse: rejectionCodeSetsResponse,
        loadingRejectionCodeSets: loadingRejectionCodeSets,
        errorRejectionCodeSets: errorRejectionCodeSets,
    };
};
